<template>
  <Modal
      v-model="_value"
      width="700"
      title="选择分组添加车辆分组"
      @on-visible-change="visibleChange"
      ok-text="添加"
      @on-ok="onOk">
    <div class="demo-split">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane" :style="treeStyle">
        <Row>
          <Select
            size="small"
            style="width: 200px; margin-right: 3px;"
            v-model="selectGroupId"
            filterable
            clearable
            remote
            :remote-method="searchGroup"
            :loading="searchGroupLoading">
            <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
<!--          <Button type="primary" size="small" style="margin-right: 3px;" @click="onClear">清空</Button>-->
<!--          <Button type="primary" size="small" @click="onAddRootVehicleInfoGroupClick">添加根分组</Button>-->
        </Row>
<!--        <Row style="margin-top: 3px;">-->
<!--          <Col span="24">-->
<!--            <li @click="onUnGroupClick">未分组车辆</li>-->
<!--          </Col>-->
<!--        </Row>-->
        <Row :style="{height:(treeHeight + 'px'), overflow:'auto'}">
          <Col span="24">
            <Tree :data="defaultGroupData" :load-data="onLoadChildrenGroupData" style="overflow: hidden;" :render="renderContent"></Tree>
          </Col>
        </Row>

      </div>
      <div slot="right" class="demo-split-pane">
    <Form ref="loginForm" :model="vehicleInfoGroup" >
      <p>父级分组: {{vehicleInfoGroup.parentGroupTitle}}</p>
      <FormItem prop="name">
        <p>
          新分组名称：
        <Input v-model="vehicleInfoGroup.name" placeholder="请输入车辆分组名称">
        </Input>
        </p>
      </FormItem>
      <FormItem prop="remark">
        <p>
          备注：
        <Input v-model="vehicleInfoGroup.remark" placeholder="备注">
        </Input>
        </p>
      </FormItem>
      <FormItem prop="description">
        <p>
          描述：
        <Input v-model="vehicleInfoGroup.description" placeholder="请输入描述">
        </Input>
        </p>
      </FormItem>
    </Form>
      </div>
    </Split>
    </div>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'addvehicleinfogroupnoparentmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      parentGroupId: null,
      nameRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '车辆分组名不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data() {
      return {
        split1:0.5,
        treeStyle: {
          'padding-left': '20px',
          'background-color': '#ffff',
          height: '100%',
          overflow: 'auto'
        },
        treeHeight: 430,


        //左侧面板内容
        searchGroupLoading: false,
        searchGroupList: [],
        selectGroupId: null,
        defaultGroupData: [],

        //右侧面板内容
        vehicleInfoGroup: {
          name:null,
          remark:null,
          description:null,
          parentGroupId:null,
          parentGroupTitle:null,
          state:null
        }
      }
    },
    methods: {
      ...mapActions([
        'UserGroupServ_AddObj'
      ]),
      onOk() {
        this.$Modal.confirm({
          title: '添加车辆分组',
          content: '<p>是否确认添加车辆分组</p>',
          onOk: () => {
            store.dispatch('VehicleInfoGroupServ_AddObj', {params: this.vehicleInfoGroup}).then(() => {
              this.$Message.success('添加车辆分组成功')
              this.$emit('on-success');
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail');
            })
          },
          onCancel: () => {
          }
        })
      },
      visibleChange(val) {
        if(val){
          this.vehicleInfoGroup.name = null
          this.vehicleInfoGroup.remark = null
          this.vehicleInfoGroup.description = null
          this.vehicleInfoGroup.parentGroupTitle = null
          this.vehicleInfoGroup.state = null
          this.vehicleInfoGroup.parentGroupId = this.parentGroupId
        }
      },

      searchGroup (input) {
        this.searchGroupLoading = true
        if (!input || input.length <= 0) {
          this.searchGroupList = []
          this.searchGroupLoading = false
        } else {
          store.dispatch('VehicleInfoGroupServ_SearchByName', {
            params: { name: input },
            urlparams: null
          }).then(() => {
            this.searchGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
            this.searchGroupLoading = false
          }).catch(err => {
            this.searchGroupLoading = false
          })
        }
      },
      //查询
      onFilterClick () {
        console.log(this.selectGroupId)
        if (this.selectGroupId) {
          console.log('加载')
          store.dispatch('VehicleInfoGroupServ_GetDetail', {
            params: { id: this.selectGroupId },
            urlparams: null
          }).then(() => {
            let result = store.getters.get_VehicleInfoGroup_GetDetailResult ? store.getters.get_VehicleInfoGroup_GetDetailResult : []
            this.defaultGroupData = [{
              id: result.id,
              title: result.name,
              expand: false,
              loading: false,
              children: []
            }]
            this.searchGroupLoading = false
          }).catch(err => {
            this.searchGroupLoading = false
          })
        } else {
          this.refreshRootVehicleInfoGroups()
        }
      },
      onClear () {
        this.selectGroupId = null
        this.defaultGroupData = null
      },
      //获取获取所有根分组
      refreshRootVehicleInfoGroups () {
        store.dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
          params: null,
          urlparams: null
        }).then(() => {
          let tempData = []
          let result = store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult ? store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult : []
          result.forEach((dtoitem, index) => {
            tempData.push({
              id: dtoitem.id,
              title: dtoitem.name + '[分组数:' + dtoitem.groupCount + ', 车辆数:' + dtoitem.vehicleInfoCount + ']',
              expand: false,
              loading: false,
              children: [],
              parent: null
            })
          })
          this.defaultGroupData = tempData
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      renderContent (h, { root, node, data }) {
        return h('span', {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, [
          h('span', [
            h('span', {
              style: {
                // fontSize:'medium',
                // backgroundColor:'#2db7f5',
                // color:'#ffffff'
              },
              on: {
                click: () => {
                  this.vehicleInfoGroup.parentGroupTitle = data.title
                  this.vehicleInfoGroup.parentGroupId = data.id
                }
              }
            }, data.title)
          ]),
        ])
      },

      onLoadChildrenGroupData (item, callback) {
        // 加载子区域
        store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
          params: { id: item.id },
          urlparams: null
        }).then(() => {
          let tempData = []
          this.tempChildrenGroups = store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult ? store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult : []
          this.tempChildrenGroups.forEach((dtoitem, index) => {
            tempData.push({
              id: dtoitem.id,
              title: dtoitem.name + '[分组数:' + dtoitem.groupCount + ', 车辆数:' + dtoitem.vehicleInfoCount + ']',
              profit: dtoitem.profit,
              expand: false,
              loading: false,
              children: [],
              parent: item
            })
          })
          callback(tempData)
        }).catch(err => {
          this.$Message.error(err)
        })
      },
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _parentGroupId: {
        get() {
          return this.parentGroupId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.refreshRootVehicleInfoGroups()

      })
    }
  }
</script>
<style>
  .demo-split{
    height: 500px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
</style>
